<template>
  <div :class="video_popup_class">
    <div class="popup_video_container relative" v-if="!has_link">
      <div class="scroll-helper">
        <div class="back-bar">
          <a href="#" class="back-link" @click.prevent="back_to_list">Back</a>
        </div>
        <img :src="img_src" :style="img_style" />
      </div>
    </div>
    <div class="popup_video_container relative" v-if="has_link">
      <div class="scroll-helper">
        <div class="back-bar">
          <a href="#" class="back-link" @click.prevent="back_to_list">Back</a>
        </div>
        <a :href="link_src" target="_blank"
          ><img :src="img_src" :style="img_style"
        /></a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "sub_image",
  props: ["item"],
  data() {
    return {
      timer: null
    };
  },
  computed: {
    ...mapState([
      "current_section",
      "current_sub_section",
      "sections_content",
      "current_secondary_section",
      "current_secondary_sub_section"
    ]),
    ...mapGetters(["sectionContent", "eventTag", "getSection"]),
    page_url() {
      var str =
        "/" +
        this.eventTag +
        "/popups/" +
        this.selected_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-")
          .toLowerCase() +
        "/" +
        this.selected_sub_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-") +
        "/image";

      return str;
    },
    img_style() {
      let style = {};

      if ("undefined" != typeof this.getCurrentSectionContent().style) {
        style = this.getCurrentSectionContent().style;
      }
      return style;
    },
    img_src() {
      return (
        "static/content/" +
        this.selected_section +
        "/" +
        this.selected_sub_section +
        "/pdf/" +
        this.item.filename
      );
    },
    link_src() {
      return this.item.link;
    },
    has_link() {
      console.log(this.item);
      return "undefined" != typeof this.item.link && this.item.link.length > 0;
    },
    is_closable() {
      return (
        this.$store.state.can_skip_videos || this.$store.state.app_state == 2
      );
    },
    show_instructions() {
      return this.$store.state.app_state != 2;
    },
    is_video_src() {
      return (
        undefined != typeof this.$store.state.popup_img_src &&
        this.$store.state.popup_img_src != ""
      );
    },
    video_popup_class() {
      return "internal-image ";
    },
    selected_section() {
      if (this.current_secondary_section != "") {
        return this.current_secondary_section;
      }
      return this.current_section;
    },
    selected_sub_section() {
      if (this.current_secondary_sub_section != "") {
        return this.current_secondary_sub_section;
      }
      return this.current_sub_section;
    },

    selected_section_name() {
      if (this.current_secondary_section != "") {
        if (this.current_secondary_section == "0") {
          return "home";
        }
        return this.current_secondary_section;
      }

      if (this.current_section === 0) {
        return "home";
      }
      return this.getSection(this.current_section).name;
    },
    selected_sub_section_name() {
      return this.selected_sub_section;
    }
  },
  methods: {
    getCurrentSectionContent() {
      return this.sectionContent(this.selected_section).subids[
        this.selected_sub_section
      ];
    },
    back_to_list() {
      this.$bus.$emit("request-subpopup-close");
    }
  }
};
</script>
<style scoped>
.scroll-helper {
  max-height: 100vh;
  display: inline-block;
  position: relative;
}
.scroll-helper img {
  display: inline-block;
  max-height: 92vh;
}
.back-bar {
  position: absolute;
  top: 0;
  right: 0;

  color: #03344a;
}

.back-bar a {
  color: #fff;
  display: inline-block;
  background: url("../../assets/close.png") 0 0 no-repeat;
  background-size: cover;
  width: 60px;
  height: 60px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
  transform: translate3d(52%, -52%, 0);
}
@media only screen and (max-width: 1110px),
  only screen and (max-height: 460px) {
  .back-bar a {
    width: 30px;
    height: 30px;
    transform: translate3d(40%, -40%, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subpopups/image.vue